import { StoreState } from '../store';
import { getTranslations, isEditorX } from './ui-settings';
import { Audience, PrivacyPolicyType, Theme, TranslationKey } from '@src/types';
import { DO_NOT_SELL_DATA_APPDEFID } from '@src/constants';
import { getCurrentInstance } from '@wix/business-manager-api';

export const getTheme = ({ pendingState }: StoreState) => pendingState?.appSettings.theme || Theme.light;

export const getSitePages = ({ sitePages }: StoreState) => sitePages || [];
export const getPrivacyPolicyType = ({ pendingState }: StoreState) =>
  pendingState?.appSettings.privacyPolicyType || PrivacyPolicyType.PageOnSite;
export const getPrivacyPolicyPage = ({ pendingState }: StoreState) => pendingState?.appSettings.privacyPolicyPage || '';
export const getPrivacyPolicyUrl = (store: StoreState) => getTranslations(store)[TranslationKey.PolicyUrl];
export const isCookiePolicyRequirementApproved = ({ pendingState }: StoreState) =>
  pendingState?.appSettings.cookiePolicyRequirementApproved || false;
export const getAudience = ({ pendingState }: StoreState) => pendingState?.appSettings.audience || Audience.AllVisitors;
export const hasPendingChanges = ({ saveState: { pendingChanges } }: StoreState) => pendingChanges;
export const getSaveFlowStatus = ({ saveState: { status } }: StoreState) => status;
export const getEditorUrlForDoNotSellApp = (store: StoreState) => {
  const { liveSite, viewMode } = store;
  if (viewMode === 'editor') {
    return 'https://www.wix.com/app-market/do-not-sell-data';
  }
  const params = isEditorX(store) && !getIsDoNotSellAppInstalled(store) ? '&openPanel=appMarket' : '';

  return `${liveSite?.editUrl || ''}/?etpa=${DO_NOT_SELL_DATA_APPDEFID}${params}`;
};

export const getIsDoNotSellAppInstalled = ({ isDoNotSellAppInstalled }: StoreState) => isDoNotSellAppInstalled;
